"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BriefcaseIcon = require("./BriefcaseIcon");

var _BriefcaseIcon2 = _interopRequireDefault(_BriefcaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BriefcaseIcon2.default;